(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["before-after-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('before-after-slider')) {
    class BeforeAfterSlider extends HTMLElement {
      connectedCallback() {
        this.compare = this.querySelector('[data-ba-compare]');
        this.handle  = this.querySelector('[data-ba-handle]');
        if (!this.compare || !this.handle) return;

        this.defaultPosition = parseFloat(this.dataset.defaultPosition);
        if (!Number.isFinite(this.defaultPosition)) this.defaultPosition = 50;

        this.hoverEnabled = this.dataset.hoverEnabled === 'true';
        this.position     = this.defaultPosition;
        this.dragging     = false;
        this._animTimer   = null;
        this._activePointer = null;

        this._onPointerDown = this._onPointerDown.bind(this);
        this._onPointerMove = this._onPointerMove.bind(this);
        this._onPointerUp   = this._onPointerUp.bind(this);
        this._onKeyDown     = this._onKeyDown.bind(this);
        this._onMouseMove   = this._onMouseMove.bind(this);
        this._onMouseLeave  = this._onMouseLeave.bind(this);

        this.compare.addEventListener('pointerdown', this._onPointerDown);
        this.handle.addEventListener('keydown', this._onKeyDown);

        if (
          this.hoverEnabled &&
          window.matchMedia('(hover: hover) and (pointer: fine)').matches
        ) {
          this.compare.addEventListener('mousemove', this._onMouseMove);
          this.compare.addEventListener('mouseleave', this._onMouseLeave);
        }

        this._setPosition(this.defaultPosition, false);
      }

      disconnectedCallback() {
        document.removeEventListener('pointermove', this._onPointerMove);
        document.removeEventListener('pointerup', this._onPointerUp);
        document.removeEventListener('pointercancel', this._onPointerUp);
        clearTimeout(this._animTimer);
      }

      _getPositionFromEvent(event) {
        const rect = this.compare.getBoundingClientRect();
        if (rect.width === 0) return this.position;
        const x = event.clientX - rect.left;
        return Math.max(0, Math.min(100, (x / rect.width) * 100));
      }

      _setPosition(value, animate) {
        this.position = value;
        this.compare.style.setProperty('--position', value + '%');
        this.handle.setAttribute('aria-valuenow', String(Math.round(value)));

        if (animate) {
          this.compare.classList.add('is-animating');
          clearTimeout(this._animTimer);
          this._animTimer = setTimeout(() => {
            this.compare.classList.remove('is-animating');
          }, 480);
        }
      }

      _onPointerDown(event) {
        if (event.pointerType === 'mouse' && event.button !== 0) return;

        this._activePointer = event.pointerId;
        this.dragging = true;
        this.compare.classList.add('is-dragging');
        this.compare.classList.remove('is-animating');

        try { this.compare.setPointerCapture(event.pointerId); } catch (e) { /* noop */ }

        event.preventDefault();

        document.addEventListener('pointermove', this._onPointerMove);
        document.addEventListener('pointerup', this._onPointerUp);
        document.addEventListener('pointercancel', this._onPointerUp);

        this._setPosition(this._getPositionFromEvent(event), false);

        try { this.handle.focus({ preventScroll: true }); }
        catch (e) { this.handle.focus(); }
      }

      _onPointerMove(event) {
        if (!this.dragging) return;
        if (this._activePointer != null && event.pointerId !== this._activePointer) return;
        if (event.cancelable) event.preventDefault();
        this._setPosition(this._getPositionFromEvent(event), false);
      }

      _onPointerUp(event) {
        if (!this.dragging) return;
        if (this._activePointer != null && event && event.pointerId !== this._activePointer) return;

        this.dragging = false;
        this._activePointer = null;
        this.compare.classList.remove('is-dragging');

        document.removeEventListener('pointermove', this._onPointerMove);
        document.removeEventListener('pointerup', this._onPointerUp);
        document.removeEventListener('pointercancel', this._onPointerUp);
      }

      _onKeyDown(event) {
        const step = event.shiftKey ? 10 : 2;
        let next = this.position;

        switch (event.key) {
          case 'ArrowLeft':
          case 'ArrowDown':
            next = Math.max(0, this.position - step); break;
          case 'ArrowRight':
          case 'ArrowUp':
            next = Math.min(100, this.position + step); break;
          case 'PageDown':
            next = Math.max(0, this.position - 10); break;
          case 'PageUp':
            next = Math.min(100, this.position + 10); break;
          case 'Home':
            next = 0; break;
          case 'End':
            next = 100; break;
          default:
            return;
        }
        event.preventDefault();
        this._setPosition(next, true);
      }

      _onMouseMove(event) {
        if (this.dragging) return;
        this._setPosition(this._getPositionFromEvent(event), false);
      }

      _onMouseLeave() {
        if (this.dragging) return;
        this._setPosition(this.defaultPosition, true);
      }
    }

    customElements.define('before-after-slider', BeforeAfterSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
